module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/ZLKYRh/tc-custom/9781035826551.jpg?1724125984064",
      "alt": "This image is the cover for the book How Was the Church Service?"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("How Was the Church Service?\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("If you want to know how to read and preach the Bible with simplicity, clarity and boldness, this book is for you. God’s design for Christianity is for people to be saved (i.e., being forgiven of their sins) and to grow in the knowledge of the Bible. The more you know the Bible, the better you live. The Apostle Paul recorded that it is God, “who desires all people to be saved and to come to the knowledge of the truth”. (1 Timothy 2:4) Dr. Tim Cantrell, in his endorsement of the book wrote, “Patrick has provided us a useful tool for digging into God’s Word, growing as a Christian, and strengthening churches. May God use this resource far and wide.”")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Musandiwa Patrick Nemabubuni\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Rev Musandiwa Patrick Nemabubuni is a reformed Christian husband to Meriam and a father to Emmanuel, Eternity and Ezra. Patrick completed his Master of Arts in Biblical Counselling at The Master’s University in California, USA, on 4 June 2018. On 6 September 2016, he became the first Black African to be accredited as a biblical counsellor by the highest authority (board) of biblical counsellors in the world called the Association of Certified Biblical Counsellors USA (www.biblicalcounseling.com). Patrick is an author and a teaching pastor in a reformed Christian church called Glorious Fellowship Church in Pretoria, South Africa.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Austin Macauley Publishers\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0